export * from './account/AuditTrailTable';
export * from './account/CreditCardsList';
export * from './account/TaxIdTextField';

export * from './ci/CITokensUsageChart';

export * from './event/LogsTable';

export * from './magic/MagicDetails';
export * from './magic/MagicForm';
export * from './magic/MagicTable';

export * from '../navigation/BaseHeaderBreadcrumbs';
export * from './instance/InstanceActionsMenu';

export * from './pod/CommitsSelector';
export * from './pod/PodsTable';
export * from './pod/ResourcePreview';
export * from './pod/ResourcesList';
export * from './pod/VersionSelector';

export * from './stacks/ClientsChart';
export * from './stacks/ErrorsChart';
export * from './stacks/EventsTable';
export * from './stacks/RangeSelector';
export * from './stacks/ServicesChart';
export * from './stacks/StackCard';
export * from './stacks/StackIcon';
export * from './stacks/StackList';
export * from './stacks/StatsChart';
export * from './stacks/mock/stacks';

export * from './subscription/CheckoutComponent';
export * from './subscription/EmulatorIcon';
export * from './subscription/EmulatorPills';
export * from './subscription/EmulatorToggle';
export * from './subscription/PlansList';
export * from './subscription/SubscriptionsList';
export * from './subscription/SubscriptionSummary';
export * from './subscription/PlanSummaryCard';
export * from './subscription/PriceWithDiscount';
export * from './subscription/ServiceCoverageLink';
export * from './subscription/StartPlanButton';

export * from './resource/apigateway/AgwApiAuthorizerDetails';
export * from './resource/apigateway/AgwApiAuthorizerForm';
export * from './resource/apigateway/AgwApiAuthorizersTable';
export * from './resource/apigateway/AgwApiDeploymentForm';
export * from './resource/apigateway/AgwApiDetails';
export * from './resource/apigateway/AgwApiForm';
export * from './resource/apigateway/AgwApiIntegrationDetails';
export * from './resource/apigateway/AgwApiIntegrationForm';
export * from './resource/apigateway/AgwApiIntegrationsTable';
export * from './resource/apigateway/AgwApiModelDetails';
export * from './resource/apigateway/AgwApiModelForm';
export * from './resource/apigateway/AgwApiModelsTable';
export * from './resource/apigateway/AgwApiRouteDetails';
export * from './resource/apigateway/AgwApiRouteForm';
export * from './resource/apigateway/AgwApiRoutesTable';
export * from './resource/apigateway/AgwApiStageDetails';
export * from './resource/apigateway/AgwApiStageForm';
export * from './resource/apigateway/AgwApiStagesTable';
export * from './resource/apigateway/AgwApisTable';
export * from './resource/apigateway/AgwRestApiAuthorizerDetails';
export * from './resource/apigateway/AgwRestApiAuthorizerForm';
export * from './resource/apigateway/AgwRestApiAuthorizersTable';
export * from './resource/apigateway/AgwRestApiDeploymentForm';
export * from './resource/apigateway/AgwRestApiDetails';
export * from './resource/apigateway/AgwRestApiForm';
export * from './resource/apigateway/AgwRestApiIntegrationDetails';
export * from './resource/apigateway/AgwRestApiIntegrationForm';
export * from './resource/apigateway/AgwRestApiIntegrationResponseDetails';
export * from './resource/apigateway/AgwRestApiIntegrationResponseForm';
export * from './resource/apigateway/AgwRestApiIntegrationResponsesTable';
export * from './resource/apigateway/AgwRestApiIntegrationsTable';
export * from './resource/apigateway/AgwRestApiKeyDetails';
export * from './resource/apigateway/AgwRestApiKeyForm';
export * from './resource/apigateway/AgwRestApiKeysTable';
export * from './resource/apigateway/AgwRestApiMethodDetails';
export * from './resource/apigateway/AgwRestApiMethodForm';
export * from './resource/apigateway/AgwRestApiMethodResponseDetails';
export * from './resource/apigateway/AgwRestApiMethodResponseForm';
export * from './resource/apigateway/AgwRestApiMethodResponsesTable';
export * from './resource/apigateway/AgwRestApiMethodsTable';
export * from './resource/apigateway/AgwRestApiModelDetails';
export * from './resource/apigateway/AgwRestApiModelForm';
export * from './resource/apigateway/AgwRestApiModelsTable';
export * from './resource/apigateway/AgwRestApiResourceDetails';
export * from './resource/apigateway/AgwRestApiResourceForm';
export * from './resource/apigateway/AgwRestApiResourcesTable';
export * from './resource/apigateway/AgwRestApiStageDetails';
export * from './resource/apigateway/AgwRestApiStageForm';
export * from './resource/apigateway/AgwRestApiStagesTable';
export * from './resource/apigateway/AgwRestApiUsagePlanDetails';
export * from './resource/apigateway/AgwRestApiUsagePlanForm';
export * from './resource/apigateway/AgwRestApiUsagePlansTable';
export * from './resource/apigateway/AgwRestApiValidatorDetails';
export * from './resource/apigateway/AgwRestApiValidatorForm';
export * from './resource/apigateway/AgwRestApiValidatorsTable';
export * from './resource/apigateway/AgwRestApisTable';

export * from './resource/appsync/AppSyncApiDetails';
export * from './resource/appsync/AppSyncApiForm';
export * from './resource/appsync/AppSyncApiKeyForm';
export * from './resource/appsync/AppSyncApiKeysTable';
export * from './resource/appsync/AppSyncApisTable';
export * from './resource/appsync/AppSyncDataSourceDetails';
export * from './resource/appsync/AppSyncDataSourceForm';
export * from './resource/appsync/AppSyncDataSourcesTable';
export * from './resource/appsync/AppSyncFunctionDetails';
export * from './resource/appsync/AppSyncFunctionForm';
export * from './resource/appsync/AppSyncFunctionsTable';
export * from './resource/appsync/AppSyncQueryForm';
export * from './resource/appsync/AppSyncResolverDetails';
export * from './resource/appsync/AppSyncResolverForm';
export * from './resource/appsync/AppSyncResolversTable';
export * from './resource/appsync/AppSyncTypeForm';
export * from './resource/appsync/AppSyncTypesTable';

export * from './resource/s3/S3BucketCreateForm';
export * from './resource/s3/S3BucketsTable';
export * from './resource/s3/S3FolderCreateForm';
export * from './resource/s3/S3ObjectBreadcrumbs';
export * from './resource/s3/S3ObjectsTable';
export * from './resource/s3/S3BucketCorsCreateForm';

export * from './resource/lambda/LambdaBreadcrumbs';
export * from './resource/lambda/LambdaCodeDetails';
export * from './resource/lambda/LambdaDetails';
export * from './resource/lambda/LambdaInvocationDetails';
export * from './resource/lambda/LambdaFunctionInvokeForm';
export * from './resource/lambda/LambdaFunctionUpdateCodeForm';
export * from './resource/lambda/LambdaEventSourceMappings';
export * from './resource/lambda/LambdaFunctionsTable';
export * from './resource/lambda/LambdaFunctionCreateForm';
export * from './resource/lambda/LambdaLayersTable';
export * from './resource/lambda/LambdaLayerCreateForm';
export * from './resource/lambda/LambdaLayerVersionsTable';
export * from './resource/lambda/LambdaTags';
export * from './resource/lambda/LambdaCapacityProvidersTable';
export * from './resource/lambda/LambdaCapacityProviderDetails';
export * from './resource/lambda/LambdaCapacityProviderForm';
export * from './resource/lambda/LambdaCapacityProviderVersionsTable';
export * from './resource/lambda/LambdaFunctionScalingConfigDetails';
export * from './resource/lambda/LambdaFunctionScalingConfigForm';

export * from './resource/backup/BackupPlanDetails';
export * from './resource/backup/BackupPlansTable';
export * from './resource/backup/BackupRulesTable';
export * from './resource/backup/BackupSelectionsTable';
export * from './resource/backup/BackupVaultDetails';
export * from './resource/backup/BackupVaultRecoveryPointsTable';
export * from './resource/backup/BackupVaultsTable';
export * from './resource/backup/BackupPlanUpsertForm';
export * from './resource/backup/BackupVaultCreateForm';
export * from './resource/backup/BackupSelectionForm';
export * from './resource/backup/BackupJobForm';

export * from './resource/timestream/TimestreamDatabaseGrid';
export * from './resource/timestream/TimestreamTablesGrid';
export * from './resource/timestream/TimestreamQueryGrid';
export * from './resource/timestream/TimestreamTableForm';
export * from './resource/timestream/TimestreamDatabaseForm';

export * from './resource/sns/SNSSubscribeForm';
export * from './resource/sns/SNSSubscriptionAttributes';
export * from './resource/sns/SNSSubscriptionDetails';
export * from './resource/sns/SNSSubscriptionTable';
export * from './resource/sns/SNSTopicAttributes';
export * from './resource/sns/SNSTopicCreateForm';
export * from './resource/sns/SNSTopicTable';
export * from './resource/sns/SNSMessagePublishForm';

export * from './resource/sqs/SQSQueueTable';
export * from './resource/sqs/SQSQueueDetails';
export * from './resource/sqs/SQSMessagesTable';
export * from './resource/sqs/SQSSendMessageForm';
export * from './resource/sqs/SQSMessageDetails';
export * from './resource/sqs/SQSQueueCreateForm';

export * from './resource/stepfunctions/StateMachineUpsertForm';
export * from './resource/stepfunctions/StateMachineExecutionEventsTable';
export * from './resource/stepfunctions/StateMachineExecutionsTable';
export * from './resource/stepfunctions/StateExecutionStartForm';
export * from './resource/stepfunctions/StateMachineFlowchart';
export * from './resource/stepfunctions/StateMachineSchema';
export * from './resource/stepfunctions/StateMachinesTable';
export * from './resource/stepfunctions/StateExecutionDetails';
export * from './resource/stepfunctions/StateMachineExecutionGroupedEventsTable';
export * from './resource/stepfunctions/StateExecutionGroupedEventDetails';

export * from './resource/cloudformation/CloudFormationForm';
export * from './resource/cloudformation/CloudFormationResourceGrid';
export * from './resource/cloudformation/CloudFormationStackGrid';
export * from './resource/cloudformation/CloudFormationOutputsGrid';

export * from './resource/cognito/CognitoGroupDetails';
export * from './resource/cognito/CognitoGroupForm';
export * from './resource/cognito/CognitoGroupsTable';
export * from './resource/cognito/CognitoPoolDetails';
export * from './resource/cognito/CognitoPoolForm';
export * from './resource/cognito/CognitoPoolsTable';
export * from './resource/cognito/CognitoUserDetails';
export * from './resource/cognito/CognitoUserForm';
export * from './resource/cognito/CognitoUserGroupAssignmentForm';
export * from './resource/cognito/CognitoUsersTable';
export * from './resource/cognito/CognitoIdentityPoolForm';
export * from './resource/cognito/CognitoIdentityPoolsTable';
export * from './resource/cognito/CognitoIdentityPoolDetail';

export * from './resource/dynamodb/DynamoDBExpressionBuilder';
export * from './resource/dynamodb/DynamoDBExpressionForm';
export * from './resource/dynamodb/DynamoDBItemsTable';
export * from './resource/dynamodb/DynamoDBTableDetails';
export * from './resource/dynamodb/DynamoDBTableForm';
export * from './resource/dynamodb/DynamoDBTablesTable';

export * from './resource/ec2/EC2InstanceDetails';
export * from './resource/ec2/EC2InstanceForm';
export * from './resource/ec2/EC2InstancesTable';
export * from './resource/ec2/ELoadBalancersV1Table';
export * from './resource/ec2/ELoadBalancerV1Form';
export * from './resource/ec2/ELoadBalancersV2Table';
export * from './resource/ec2/ELoadBalancerV2Form';
export * from './resource/ec2/SecurityGroupDetails';
export * from './resource/ec2/SecurityGroupForm';
export * from './resource/ec2/SecurityGroupsTable';
export * from './resource/ec2/VPCDetails';
export * from './resource/ec2/VPCForm';
export * from './resource/ec2/VPCsTable';

export * from './resource/iam/IAMGroupDetails';
export * from './resource/iam/IAMGroupForm';
export * from './resource/iam/IAMGroupsTable';
export * from './resource/iam/IAMPoliciesTable';
export * from './resource/iam/IAMPolicyDetails';
export * from './resource/iam/IAMPolicyForm';
export * from './resource/iam/IAMPolicyVersion';
export * from './resource/iam/IAMPolicyVersionForm';
export * from './resource/iam/IAMRoleDetails';
export * from './resource/iam/IAMRoleForm';
export * from './resource/iam/IAMRolesTable';
export * from './resource/iam/IAMUserDetails';
export * from './resource/iam/IAMUserForm';
export * from './resource/iam/IAMUsersTable';
export * from './resource/iam/IAMRolePoliciesTable';
export * from './resource/iam/IAMRoleAttachPolicyForm';
export * from './resource/iam/IAMRolePolicyUpsertForm';

export * from './resource/cloudwatch/CloudWatchLogGroupForm';
export * from './resource/cloudwatch/CloudWatchLogGroupsTable';
export * from './resource/cloudwatch/CloudWatchLogStreamForm';
export * from './resource/cloudwatch/CloudWatchLogStreamsTable';

export * from './resource/ses/SESV2IdentityForm';
export * from './resource/ses/SESV2MessageForm';

export * from './resource/ses/SESIdentitiesTable';
export * from './resource/ses/SESV1IdentityForm';
export * from './resource/ses/SESMessageDetails';
export * from './resource/ses/SESV1MessageForm';
export * from './resource/ses/SESMessagesTable';

export * from './resource/rds/RDSDatabasesTable';
export * from './resource/rds/RDSDatabaseDetails';
export * from './resource/rds/RDSGlobalDatabaseForm';
export * from './resource/rds/RDSInstanceDetails';
export * from './resource/rds/RDSInstanceForm';
export * from './resource/rds/RDSResultsTable';
export * from './resource/rds/RDSClusterDetails';
export * from './resource/rds/RDSClusterForm';
export * from './resource/rds/RDSSecretForm';

export * from './resource/secretsmanager/SecretsManagerSecretDetails';
export * from './resource/secretsmanager/SecretsManagerSecretsTable';
export * from './resource/secretsmanager/SecretsManagerSecretForm';

export * from './resource/systemparameters/SystemParameterDetails';
export * from './resource/systemparameters/SystemParameterForm';
export * from './resource/systemparameters/SystemParametersTable';

export * from './resource/cloudtrail/CloudTrailCreateForm';
export * from './resource/cloudtrail/CloudTrailDetails';
export * from './resource/cloudtrail/CloudTrailEventDetails';
export * from './resource/cloudtrail/CloudTrailEventsTable';
export * from './resource/cloudtrail/CloudTrailTable';

export * from './resource/metrics/MonitoringAlarmDetails';
export * from './resource/metrics/MonitoringAlarmForm';
export * from './resource/metrics/MonitoringAlarmsTable';
export * from './resource/metrics/MonitoringGraphControls';
export * from './resource/metrics/MonitoringMetricDetails';
export * from './resource/metrics/MonitoringMetricForm';
export * from './resource/metrics/MonitoringMetricsChart';
export * from './resource/metrics/MonitoringMetricsTable';

export * from './resource/mq/MQBrokersTable';
export * from './resource/mq/MQBrokerForm';
export * from './resource/mq/MQBrokerDetails';

export * from './resource/eventbridge/EventBridgeBusDetails';
export * from './resource/eventbridge/EventBridgeBusesTable';
export * from './resource/eventbridge/EventBridgeBusForm';
export * from './resource/eventbridge/EventBridgeEventForm';
export * from './resource/eventbridge/EventBridgeRuleForm';
export * from './resource/eventbridge/EventBridgeRulesTable';
export * from './resource/eventbridge/EventBridgeTargetDetails';
export * from './resource/eventbridge/EventBridgeTargetForm';
export * from './resource/eventbridge/EventBridgeTargetsTable';

export * from './resource/eventbridge/EventBridgePipesTable';
export * from './resource/eventbridge/EventBridgePipeDetails';
export * from './resource/eventbridge/EventBridgePipeForm';

export * from './resource/elasticache/ElastiCacheClusterDetails';
export * from './resource/elasticache/ElastiCacheClusterForm';
export * from './resource/elasticache/ElastiCacheClustersTable';

export * from './resource/kafka/KafkaClusterDetails';
export * from './resource/kafka/KafkaClusterForm';
export * from './resource/kafka/KafkaClustersTable';

export * from './resource/kinesis/KinesisStreamDetails';
export * from './resource/kinesis/KinesisStreamForm';
export * from './resource/kinesis/KinesisStreamsTable';

export * from './resource/kms/KMSKeyDetails';
export * from './resource/kms/KMSKeyForm';
export * from './resource/kms/KMSKeysTable';

export * from './resource/athena/AthenaDatabaseItemsTable';
export * from './resource/athena/AthenaDatabasesTable';
export * from './resource/athena/AthenaDataCatalogForm';
export * from './resource/athena/AthenaDataCatalogsTable';

export * from './resource/ecs/ECSClusterDetails';
export * from './resource/ecs/ECSClusterForm';
export * from './resource/ecs/ECSClustersTable';
export * from './resource/ecs/ECSServiceDetails';
export * from './resource/ecs/ECSServiceForm';
export * from './resource/ecs/ECSServicesTable';
export * from './resource/ecs/ECSTaskDefinitionDetails';
export * from './resource/ecs/ECSTaskDefinitionForm';
export * from './resource/ecs/ECSTaskDefinitionsTable';
export * from './resource/ecs/ECSTaskDetails';
export * from './resource/ecs/ECSTaskForm';
export * from './resource/ecs/ECSTasksTable';

export * from './resource/ecr/ECRRepositoriesTable';
export * from './resource/ecr/ECRRepositoryCreateForm';
export * from './resource/ecr/ECRImagesTable';
export * from './resource/ecr/ECRImageCreateForm';

export * from './resource/glue/GlueDatabasesTable';
export * from './resource/glue/GlueDatabaseForm';
export * from './resource/glue/GlueTablesGrid';
export * from './resource/glue/GlueTableForm';
export * from './resource/glue/GlueTableDetails';
export * from './resource/glue/GlueConnectionsTable';
export * from './resource/glue/GlueConnectionDetails';
export * from './resource/glue/GlueConnectionForm';
export * from './resource/glue/GlueCrawlersTable';
export * from './resource/glue/GlueCrawlerForm';
export * from './resource/glue/GlueCrawlerDetails';
export * from './resource/glue/GlueJobsTable';
export * from './resource/glue/GlueJobForm';
export * from './resource/glue/GlueJobDetails';
export * from './resource/glue/GlueJobRunsTable';
export * from './resource/glue/GlueJobRunDetails';
export * from './resource/glue/GlueRegistriesTable';
export * from './resource/glue/GlueRegistryDetails';
export * from './resource/glue/GlueRegistryForm';
export * from './resource/glue/GlueSchemasTable';
export * from './resource/glue/GlueSchemaForm';
export * from './resource/glue/GlueSchemaDetails';
export * from './resource/glue/GlueSchemaVersionsTable';
export * from './resource/glue/GlueSchemaVersionDetails';
export * from './resource/glue/GlueSchemaVersionForm';
export * from './resource/glue/GlueTablePartitionsGrid';
export * from './resource/glue/GlueSchemaVersionMetadataTable';
export * from './resource/glue/GlueSchemaVersionMetadataForm';

export * from './resource/neptune/NeptuneInstanceForm';
export * from './resource/neptune/NeptuneClusterForm';
export * from './resource/neptune/NeptuneClustersTable';
export * from './resource/neptune/NeptuneInstancesTable';
export * from './resource/neptune/NeptuneInstanceDetails';
export * from './resource/neptune/NeptuneClusterDetails';

export * from './resource/sagemaker/SGMModelsTable';
export * from './resource/sagemaker/SGMModelForm';
export * from './resource/sagemaker/SGMEndpointsTable';
export * from './resource/sagemaker/SGMEndpointForm';
export * from './resource/sagemaker/SGMEndpointConfigsTable';
export * from './resource/sagemaker/SGMEndpointConfigForm';

export * from './resource/application-autoscaling/ScalableTargetsTable';
export * from './resource/application-autoscaling/ScalableTargetForm';

export * from './resource/route53/Route53HostedZonesTable';
export * from './resource/route53/Route53HostedZoneCreateForm';
export * from './resource/route53/Route53HostedZoneDetails';
export * from './resource/route53/Route53HostedZonesRecordsTable';
export * from './resource/route53/Route53HostedZoneRecordDetails';
export * from './resource/route53/Route53HostedZoneRecordForm';

export * from './resource/route53/Route53ResolverEndpointsTable';
export * from './resource/route53/Route53ResolverEndpointForm';
export * from './resource/route53/Route53ResolverEndpointDetails';

export * from './resource/cloudfront/CloudFrontDistributionsTable';
export * from './resource/cloudfront/CloudFrontDistributionForm';
export * from './resource/cloudfront/CloudFrontDistributionDetails';

export * from './resource/opensearch/OpenSearchDomainsTable';
export * from './resource/opensearch/OpenSearchDomainForm';
export * from './resource/opensearch/OpenSearchDomainDetails';

export * from './resource/docdb/DocDBInstanceForm';
export * from './resource/docdb/DocDBInstanceDetail';
export * from './resource/docdb/DocDBClustersTable';
export * from './resource/docdb/DocDBClusterForm';
export * from './resource/docdb/DocDBClusterDetail';

export * from './resource/lambdaweb/LambdaWebFunctionsTable';
export * from './resource/lambdaweb/LambdaWebFunctionDetails';
export * from './resource/lambdaweb/LambdaWebRevisionsTable';
export * from './resource/lambdaweb/LambdaWebEndpointsTable';
export * from './resource/appconfig/AppConfigApplicationsTable';
export * from './resource/appconfig/AppConfigApplicationForm';
export * from './resource/appconfig/AppConfigApplicationDetail';

export * from './resource/acm/ACMCertificatesTable';
export * from './resource/acm/ACMCertificateForm';
export * from './resource/acm/ACMCertificateDetail';

export * from './resource/mwaa/MWAAEnvironmentsTable';
export * from './resource/mwaa/MWAAEnvironmentForm';
export * from './resource/mwaa/MWAAEnvironmentDetail';

export * from './resource/amplify/AmplifyAppsTable';
export * from './resource/amplify/AmplifyAppForm';
export * from './resource/amplify/AmplifyAppDetail';
export * from './resource/amplify/AmplifyBEEnvironmentDetails';
export * from './resource/amplify/AmplifyBEEnvironmentForm';
export * from './resource/amplify/AmplifyBEEnvironmentsTable';

export * from './resource/eks/EKSClustersTable';
export * from './resource/eks/EKSClusterForm';
export * from './resource/eks/EKSClusterDetail';

export * from './resource/transcribe/TranscriptionJobsTable';
export * from './resource/transcribe/TranscriptionJobDetails';
export * from './resource/transcribe/TranscriptionJobForm';

export * from './resource/codecommit/CodeCommitRepositoriesTable';
export * from './resource/codecommit/CodeCommitRepositoryForm';
export * from './resource/codecommit/CodeCommitRepositoryDetail';

export * from './resource/ce/CECostCategoryDefinitionsTable';
export * from './resource/ce/CECostCategoryDefinitionForm';
export * from './resource/ce/CECostCategoryDefinitionDetail';

export * from './resource/account/ContactInformationForm';
export * from './resource/account/ContactInformationTable';
export * from './resource/account/AlternateContactForm';
export * from './resource/account/AlternateContactTable';

export * from './resource/dms/DMSReplicationInstancesTable';
export * from './resource/dms/DMSReplicationInstanceForm';
export * from './resource/dms/DMSReplicationInstanceDetail';
export * from './resource/dms/DMSEndpointsTable';
export * from './resource/dms/DMSEndpointForm';
export * from './resource/dms/DMSEndpointDetail';
export * from './resource/dms/DMSReplicationTasksTable';
export * from './resource/dms/DMSReplicationTaskForm';
export * from './resource/dms/DMSReplicationTaskDetail';
export * from './resource/dms/DMSReplicationTaskTableStatsTable';
export * from './resource/dms/DMSEndpointConnectionsTable';
export * from './resource/dms/DMSEndpointConnectionTestForm';

export * from './resource/redshift/RedshiftClusterDetail';
export * from './resource/redshift/RedshiftClusterForm';
export * from './resource/redshift/RedshiftClustersTable';

export * from './resource/firehose/FirehoseStreamCreateForm';
export * from './resource/firehose/FirehoseStreamDetails';
export * from './resource/firehose/FirehoseStreamsTable';
export * from './resource/lambdaweb/LambdaWebFunctionCreateForm';
export * from './resource/lambdaweb/LambdaWebRevisionCreateForm';
export * from './resource/lambdaweb/LambdaWebEndpointForm';
export * from './resource/lambdaweb/LambdaWebEndpointDetails';
